import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'CREATE_OPER',
  title: 'Comment créer une opération ?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Pour créer une opération :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Cliquez sur l’onglet « Opérations »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CREATE_OPER/FR_CREATE_OPER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Cliquez sur « Ajouter une nouvelle opération »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CREATE_OPER/FR_CREATE_OPER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Choisissez le type d’opération à créer'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CREATE_OPER/FR_CREATE_OPER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Choisissez quel est votre rôle concernant cette opération'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CREATE_OPER/FR_CREATE_OPER_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Renseignez les informations concernant l’opération'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CREATE_OPER/FR_CREATE_OPER_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '6.',
    value: 'Validez'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CREATE_OPER/FR_CREATE_OPER_6.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Il ne vous reste plus qu’à sélectionner les documents requis et donner accès à l’opération à vos collaborateurs. (Voir catégorie « Mes opérations »).'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Si vous n’avez pas la possibilité de créer une opération, contactez votre Service Clients.'
  }]
};
